import { Check, Xmark } from 'iconoir-react';
import React from 'react';
import toast from 'react-hot-toast';
import { PiX } from 'react-icons/pi';

interface ToasterProps {
  message: string;
  type: 'success' | 'error';
  onClose?: () => void;
  id: string;
}

const Toaster = (props: ToasterProps) => {
  const { message, type, onClose, id } = props;

  const icon =
    type === 'success' ? (
      <Check className='w-4 h-4 text-green-700' />
    ) : (
      <Xmark className='w-4 h-4 text-red-600' />
    );

  const handleClose = () => {
    onClose?.();
    toast.dismiss(id);
  };

  const buttonClass = 'cursor-pointer absolute right-5 top-[1.45rem] z-10';

  const baseClass =
    'md:max-w-[30rem] max-w-[90%] flex items-center gap-4 p-5 pe-[3.375rem] rounded-xl text-white text-sm';

  const computedClass = `${baseClass} ${type === 'success' ? 'bg-green-600' : 'bg-red-600'}`;

  return (
    <span className={computedClass}>
      <div className='flex items-center justify-center w-6 h-6 min-w-6 rounded-xl bg-white'>
        {icon}
      </div>
      {message}
      <button onClick={handleClose} className={buttonClass}>
        <PiX size={18} />
      </button>
    </span>
  );
};

export default Toaster;
